var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal-target',{class:_vm.targetClass,attrs:{"name":_vm.$constants.PORTALS_NAMES.massActionsPanel,"multiple":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }